import React from "react";
import { useNode } from "@craftjs/core";
import styled from "@emotion/styled";

const NoBlockStyled = styled.div<any>`
  min-height: 150px;
  background-color: blue;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(26, 115, 232, 0.05);
  border: 1px solid rgba(26, 115, 232, 1);

  :after {
    display: flex;
    margin: auto;
    content: "+ Add Block";
    text-align: center;
    font-family: Inter, Helvetica, Arial, sans-serif;
    background-color: rgba(26, 115, 232, 1);
    color: white;
    cursor: pointer !important;
    font-size: 16px;
    padding: 15px 25px;
    border-radius: 5px;
  }
`;

export const NoBlock = () => {
  return <NoBlockStyled />;
};
